import type { SVGIconProps } from '@/components_deprecated/icons'
import type { LinkProps } from 'react-router'
import { ShortcutA, ShortcutLink, ShortcutSVG } from './components'

interface IconShortcutCommonProps {
  iconProps: Pick<SVGIconProps, 'icon' | 'width'>
  text: string
}

interface IconShortcutInternalProps extends IconShortcutCommonProps {
  linkProps: Pick<LinkProps, 'to' | 'className'>
}

interface IconShortcutExternalProps extends IconShortcutCommonProps {
  external: true
  href: string
}

function isIconShortcutInternalProps(
  props: IconShortcutProps
): props is IconShortcutInternalProps {
  return 'linkProps' in props && !('external' in props && props.external)
}

export type IconShortcutProps =
  | IconShortcutInternalProps
  | IconShortcutExternalProps

export const IconShortcut: React.FC<IconShortcutProps> = props => {
  if (isIconShortcutInternalProps(props))
    return (
      <ShortcutLink {...props.linkProps}>
        <ShortcutSVG {...props.iconProps} />
        <p>{props.text}</p>
      </ShortcutLink>
    )
  else
    return (
      <ShortcutA href={props.href} target="_blank" rel="noopener noreferrer">
        <ShortcutSVG {...props.iconProps} />
        <p>{props.text}</p>
      </ShortcutA>
    )
}
